import { AlertCircle, CheckCircle, Clock, X } from "lucide-react";

/**
 * Default limit for report items returned from API
 */
export const DEFAULT_REPORT_LIMIT = 200;

/**
 * Default number of days to look back for date range
 */
export const DEFAULT_DATE_RANGE_DAYS = 30;

/**
 * Status configuration for execution status display
 */
export const STATUS_CONFIG = {
  COMPLETED: {
    label: "OK",
    color: "bg-green-100 text-green-700",
    icon: CheckCircle,
  },
  RUNNING: {
    label: "Em execução",
    color: "bg-blue-100 text-blue-700",
    icon: Clock,
  },
  MISSED: {
    label: "Perdido",
    color: "bg-red-100 text-red-700",
    icon: X,
  },
  TIMED_OUT: {
    label: "Expirado",
    color: "bg-orange-100 text-orange-700",
    icon: AlertCircle,
  },
  PROBLEMAS: {
    label: "Problemas",
    color: "bg-yellow-100 text-yellow-700",
    icon: AlertCircle,
  },
} as const;

export type StatusConfigKey = keyof typeof STATUS_CONFIG;
